module.exports = __webpack_public_path__ + "rakiety.svg";